export default __webpack_public_path__ + "static/media/destruction.09fb5027.mp3";